export class EstimationDistrictWiseModel {   
    District: string;
    TotalApplication: number;
    VerifiedApplication:number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    Est_Amount:number;
    Mi_Area:number;
}
export class EstimationMonthWiseModel {   
    Months: string;
    Years: string;
    TotalApplication: number;
    VerifiedApplication:number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    Est_Amount:number;
    Mi_Area:number;
}
export class EstimationUserWiseModel {   
    UserID: any;
    Level_ID:string;
    TotalApplication: number;
    VerifiedApplication:number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    Est_Amount:number;
    Mi_Area:number;
}
export class EstimationVendorWiseModel {   
    VendorName: string;
    Vendor_Code: string;
    TotalApplication: number;
    VerifiedApplication:number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    Est_Amount:number;
    Mi_Area:number;
}

export class BoqDistrictWiseModel {   
    District: any;
    TotalApplication: number;
    VerifiedApplication:number;
    BOQAmount: number;
    Mi_Area:number;
}
export class  BoqMonthWiseModel {   
    Months: string;
    Years: string;
    TotalApplication: number;
    VerifiedApplication:number;
    BOQAmount: number;
    Mi_Area:number;
}
export class BoqVendorWiseModel {   
    VendorName: string;
    Vendor_Code: string;
    TotalApplication: number;
    VerifiedApplication:number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    BOQAmount: number;
    Mi_Area:number;
}
export class BoqMiTypeWiseModel {   
    District: any;
    Block:string;
    MIType:string;
    TotalApplication: number;
    VerifiedApplication:number;
    BOQAmount: number;
    Mi_Area:number;
}
export class EstimationVerificationDistrictWiseModel {   
    District: string;
    MIType: string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    RejectedApplication: number;
    Est_Amount: number;
    Mi_Area: number;
}
export class EstimationVerificationMonthWiseModel {   
    Months: string;
    Years: string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication:number;
    PendingApplication:number;
    RejectedApplication:number;
    Est_Amount:number;
    Mi_Area:number;
}
export class EstimationVerificationUserWiseModel {   
    UserID: any;
    Level_ID:string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication:number;
    PendingApplication:number;
    RejectedApplication:number;
    Est_Amount:number;
    Mi_Area:number;
}
export class EstimationVerificationVendorWiseModel {   
    VendorName: string;
    MIType: string;
    Vendor_Code: string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication:number;
    PendingEarly:number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    RejectedApplication:number;
    Est_Amount: number;
    Mi_Area: number;
}
export class ChallanDistrictWiseModel {
    District: string;
    ChallanGenerated: number;
    ChallanAmount: number;
    ChallanDeposited: number;
    AmountDeposited: number;
}
export class ChallanMonthWiseModel {
    Months: string;
    ChallanGenerated: number;
    ChallanAmount: number;
    ChallanDeposited: number;
    AmountDeposited: number;
}
export class ChallanVendorWiseModel {
    VendorName: string;
    ChallanGenerated: number;
    ChallanAmount: number;
    ChallanDeposited: number;
    AmountDeposited: number;
}

export class PhysicalVerificationMonthWiseModel {   
    Months: string;
    Years: string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication:number;
    PendingEarly:number;
    Pending_1Week:number;
    Pending_Morethan_1Weeks:number;
    RejectedApplication:number;
    PVAmount:number;
    PVArea:number;
}

export class PhysicalVerificationDistrictWiseModel {   
    District: string;
    Block: string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    RejectedApplication: number;
    PVAmount: number;
    PVArea: number;
}

export class PhysicalVerificationUserWiseModel {   
    UserID: any;
    Level_ID:string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication:number;
    PendingEarly:number;
    Pending_1Week:number;
    Pending_Morethan_1Weeks:number;
    RejectedApplication:number;
    PVAmount:number;
    PVArea:number;
}
export class PhysicalVerificationVendorWiseModel {   
    VendorName: string;
    Vendor_Code: string;
    TotalApplication: number;
    VerifiedApplication:number;
    ReturnProcessApplication:number;
    PendingEarly:number;
    Pending_1Week:number;
    Pending_Morethan_1Weeks:number;
    RejectedApplication:number;
    PVAmount:number;
    PVArea:number;
}

export class FsvDistrictWiseModel {   
    District: string;
    Block: string;
    FSVDeposited: number;
    FSVPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    AmountPaid: number;
    MIArea: number;
}

export class FsvVendorWiseModel {   
    VendorName: string;
    Vendor_Code: string;
    FSVDeposited: number;
    FSVPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks:number; 
    AmountPaid: number;
    MIArea:number;
}
export class FsvMonthWiseModel {   
    Months: string;
    Years: string;
    FSVDeposited:number;
    FSVPaid:number;
    PendingEarly:number;
    Pending_1Week:number;
    Pending_Morethan_1Weeks:number;
    AmountPaid:number;
    MIArea:number;
}
export class StvVendorWiseModel {   
    VendorName: string;
    Vendor_Code: string;
    TotalApplication: number;
    SubsidyPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks:number; 
    AmountPaid: number;
    MIArea:number;
}

export class StfDistrictWiseModel {   
    District: string;
    Block: string;
    TotalApplication: number;
    SubsidyPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    AmountPaid: number;
    MIArea: number;
}

export class StvMonthWiseModel {   
    Months: string;
    Years: string;
    TotalApplication: number;
    SubsidyPaid:number;
    PendingEarly:number;
    Pending_1Week:number;
    Pending_Morethan_1Weeks:number;
    AmountPaid:number;
    MIArea:number;
}

export class StvDistrictWiseModel {   
    District: string;
    Block: string;
    TotalApplication: number;
    SubsidyPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    AmountPaid: number;
    MIArea: number;
}

export class StfVendorWiseModel {   
    VendorName: string;
    Vendor_Code: string;
    TotalApplication: number;
    SubsidyPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks:number; 
    AmountPaid: number;
    MIArea:number;
}

export class StfMonthWiseModel {   
    Months: string;
    Years: string;
    TotalApplication:number;
    SubsidyPaid:number;
    PendingEarly:number;
    Pending_1Week:number;
    Pending_Morethan_1Weeks:number;
    AmountPaid:number;
    MIArea:number;
}

export class RtfDistrictWiseModel {   
    District: string;
    Block: string;
    FSVDeposited: number;
    FSVPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    AmountPaid: number;
    MIArea: number;
}

export class RtfMonthWiseModel {   
    Months: string;
    Years: string;
    FSVDeposited: number;
    FSVPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    AmountPaid: number;
    MIArea: number;
}

export class RtfVendorWiseModel {   
    District: string;
    Block: string;
    FSVDeposited: number;
    FSVPaid: number;
    PendingEarly: number;
    Pending_1Week: number;
    Pending_Morethan_1Weeks: number;
    AmountPaid: number;
    MIArea: number;
}

export class VendorMiArea {   
    vendorName: string;
    ProgrammeName: string;
    Verified_App_Area: number;
    Pending_App_Area: number;
    Incomplete_App_Area: number;
    Rejected_App_Area: number;
    changeRequest_App_Area: number;
    Total_App_Area: number;
    TargerArea: number;
}

export class MiVerificationSubsidy {   
    District: string;
    Block: string;
    Constituency: string;
    Village: string;
    Application_No: string;
    farmerName: string;
    Father_name: string;
    ProgrammeName: string;
    TotalArea: number;
    EstimateAmount: number;
    BOQAmount: number;
    PVAmount: number;
    verification_date: string;
    Mobile: string;
    VendorName: string;
}

export class Stage1 {   
    district: string;
    Total_App_Recieved: number;
    recieved_Coverage_Area: number;
    total_Approved_Application: number;
    approved_Coverage_Area: number;
    total_App_Incomplete: number;
    total_App_Pending: number;
    total_App_Rejected: number;
    total_Intimation_Stage1: number;
    pending_At_JE: number;
    pending_At_XEN: number;
    pending_At_DMICADA: number;
    pending_At_Admin: number;
    PHY_Done: number;
}

export class TankAbstract {   
    District: string;
    Tank_App: number;
    Tank_Coverage_Area: number;
    Tank_Verified_App: number;
    Tank_RP_App: number;
    tank_Rejected_App: number;
    Tank_Verified_Coverage_Area: number;
}

export class Stage2 {   
    District: string;
    Total_App_Recieved: number;
    recieved_Coverage_Area: number;
    total_Approved_Application: number;
    approved_Coverage_Area: number;
    total_App_Incomplete: number;
    total_App_Pending: number;
    total_App_Rejected: number;
    total_Intimation_Stage1: number;
    pending_At_JE: number;
    pending_At_XEN: number;
    pending_At_DMICADA: number;
    pending_At_Admin: number;
    PHY_Done: number;
}

export class Stage3 {   
    District: string;
    Total_App_Recieved: number;
    recieved_Coverage_Area: number;
    total_Approved_Application: number;
    approved_Coverage_Area: number;
    total_App_Incomplete: number;
    total_App_Pending: number;
    total_App_Rejected: number;
    pending_At_DMICADA: number;
    pending_At_Admin: number;
}

export class Stage1Subsidy {   
    District: string;
    Block: string;
    Village: string;
    AppID: string;
    farmerName: string;
    Adm_Amount: number;
    farmer_Mobile: string;
    Approval_Date: string;
}

export class Stage2Subsidy {   
    District: string;
    Block: string;
    Village: string;
    AppID: string;
    farmerName: string;
    Adm_Amount: number;
    farmer_Mobile: string;
    Approval_Date: string;
}

export class Stage3Subsidy {   
    District: string;
    Block: string;
    Village: string;
    AppID: string;
    farmerName: string;
    Adm_Amount: number;
    farmer_Mobile: string;
    Approval_Date: string;
}
export class CanalAndTubewellBased {   
    Water_Source: string;
    ApplicationRecieved: number;
    TotalArea: number;
    Verified_Application: number;
    App_Verified_Area: number;
    estimateApproved: number;
    estimatePending: number;
    BOQ_Uploaded: number;
    BOQ_Pending: number;
    PV_Approved: number;
    PV_Pending: number;
    DMICADA_Approved: number;
    DMICADA_Pending: number;
}